import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const Container = styled.div`
  width: 100%;
  padding: 12px;
  height: fit-content;
  display: flex;
  gap: 24px;
  flex-direction: column;

  background: ${baseTheme.colors.white};

  @media ${baseTheme.device.mobileL} {
    justify-content: space-between;
    flex-direction: row;
    width: 1060px;
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);
  }
`

export const Wrapper = styled.div`
  flex: 1;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
`
